const locales = {
  en: {
    "moto_before": "Commander",
    "moto": "MOTO",
    "moto_skill_1": "Order Calling",
    "moto_skill_2": "Charge Calling",
    "moto_skill_3": "",
    "moto_introduction_1": "An Imperial General who leads a powerful army, as well as a Synthetic Troop Mentor who studies Ember.\n'It would have been better to take home a piece of scrap iron than you!' —Moto often says this to his adopted son Bing.",
    "moto_introduction_2": "A violent leader who charges into battles and orders his war machines to fight violence with violence.\n'It is said that this respectable dwarf lost his jaw in an explosion. I wonder where the beard under his mask is from. '",
    "carino_before": "Divineshot",
    "carino": "CARINO",
    "carino_skill_1": "Ranger of Glory",
    "carino_skill_2": "Lethal Flash",
    "carino_skill_3": "Zealot of War",
    "carino_introduction_1": "This noble and righteous ranger is an ammo expert with excellent marksmanship.\n'When Carino was a child, he always came crying to me and called me his uncle. Time is not forgiving at all! ' —Youga's carefree lamentation.",
    "carino_introduction_2": "A deadly hunter who walks in the dark after committing the crime of regicide.\n'Gunners' are usually most vulnerable when they reload, but he is the exception. '",
    "carino_introduction_3": "The weapon of war that destroys everything, the ultimate zealot who sparks conflict.\nThe war will not cease, as zealots dedicate their lives to perpetuating the war.",
    "rehan_before": "Berserker",
    "rehan": "REHAN",
    "rehan_skill_1": "Anger",
    "rehan_skill_2": "Seething Spirit",
    "rehan_skill_3": "Wrathstorm",
    "rehan_introduction_1": "A barbarian warrior who turns rage into strength. He accumulates his rage in battles to become more courageous with each battle.\nRehan loves to sing. It is said that Rehan once planned to organize a snowfield concert tour before Aember destroyed his home.",
    "rehan_introduction_2": "Rehan offers his rage to his Ancestor Spirit in exchange for its protection and fights alongside the Ancestor Spirit of Varagon.\nRehan was actually very nervous when he secretly ate the offerings in the Valley of the Ancestors. Maybe the Ancestor Spirit was watching him at that time.",
    "gemma_before": "Frostfire",
    "gemma": "GEMMA",
    "gemma_skill_1": "Ice-Fire Fusion",
    "gemma_skill_2": "Frostbitten Heart",
    "gemma_skill_3": "Flame Form",
    "gemma_skill_4": "Flame of Pleasure",
    "gemma_introduction_1": "With two intertwined and inseparable souls, one frosty and another fiery, she is both the hottest flame and the coldest ice.\n'Listening to the quarrels of Gemma's heart and commenting on this is part of Thea's daily schedule.'",
    "gemma_introduction_2": "A lonely soul who exists in the wind and snow with a gentle yet frigid heart of ice that will never melt.\n'Erika, take your half-eaten rats off my bed. I'm not a fridge.'",
    "gemma_introduction_4": "Endless ecstasy in the fiery feast, foolish subjects infatuated under the skirt.\n\"Come on, let me taste the flavor of your pain.\"",
    "youga_before": "Spacetime Witness",
    "youga": "YOUGA",
    "youga_skill_1": "Spacetime Illusion",
    "youga_skill_2": "Spacetime Elapse",
    "youga_skill_3": "Spacetime Witness",
    "youga_introduction_1": "I'm the perfect combination of technology and magic, the chosen one of time and space, and the pillar of Torchlight.\n'Hey! I'm the real Youga! Don't listen to that imposter! '",
    "youga_introduction_2": "I thought that being torn to pieces in spacetime turbulence is the worst thing that could happen, but the more miserable reality is that this spacetime turbulence has made a home in me! \nI wear these bandages so that I can see those physicists argue whether I'm alive under the bandages. ",
    "thea_before": "Oracle",
    "thea": "THEA",
    "thea_skill_1": "Wisdom of The Gods",
    "thea_skill_2": "Incarnation of The Gods",
    "thea_skill_3": "BLASPHEMER",
    "thea_introduction_1": "Blessed by the Six Gods, Oracle uses the gods' blessings to predict the future and mete out Divine Punishment.\n'The teachings of the Six Gods shall guide your way.'",
    "thea_introduction_2": "Gather the might of the gods and bring back the Divine Realm.\n'Everything I do is the will of the gods. '",
    "thea_introduction_3": "\"When the seventh confession echoed through the void, I understood our curse is eternal—a chorus of sins, each whispered in a different tongue, yet all steeped in decay.\"",
    "comming": "COMING SOON",
    "erika_before": "Cateye",
    "erika": "ERIKA",
    "erika_skill_1": "Wind Stalker",
    "erika_skill_2": "Lightning Cat Shadow",
    "erika_skill_3": "",
    "erika_introduction_1": "A skilled huntress who has cat ears and moves like the wind.\n'Hehe, I'm Erika, and I run faster than a lightning bolt! '",
    "erika_introduction_2": "Erika, the leading lightning researcher, obliterates enimies with the electrifying light!\nAs long as Erika keeps running, Torchlight will never power off!",
    "bing_before": "Escapist",
    "bing": "BING",
    "bing_skill_1": "Blast Nova",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "A demolition artist who does things with a bang and likes to run around causing trouble.\n'He became famous instantly after successively selling bomb briefs to Rehan.'",
    "iris_before": "The Forsaken",
    "iris": "IRIS",
    "iris_skill_1": "Growing Breeze",
    "iris_skill_2": "Vigilant Breeze",
    "iris_introduction_1": "Spirit Magus Squad's close companion, the gentle breeze that strives to grow.\nWe are growing, like everything in this world.",
    "iris_introduction_2": "In the depths of the arcane, a gentle guardian stands, a warm breeze cutting through the chill of despair.\n\"We forge a shield of light to defend the very essence of creation.\"",
    "rosa_before": "Lightbringer",
    "rosa": "ROSA",
    "rosa_skill_1": "High Court Chariot",
    "rosa_introduction_1": "The unruly apprentice knight of St. Duran, the fearless Holy Court Chariot on the battlefield. \"The Holy Spirit will forgive you, and I will send you to meet the Holy Spirit.\"",
    "selena_before": "Tide Whisper",
    "selena": "SELENA",
    "selena_skill_1": "Sing with the Tide",
    "selena_introduction_1": "May the tides of the sea caress the earth, while the echoes of a haunting melody pierce the depths of the soul.\"From now on, I shall sing only for myself.\"",
    "intro_title": "Introduction"
  },
  tw: {
    "moto_before": "指揮官",
    "moto": "莫托",
    "moto_skill_1": "號令徵召",
    "moto_skill_2": "衝鋒徵召",
    "moto_skill_3": "聯合徵召",
    "moto_introduction_1": "統率勁旅的帝國將軍，精研灰燼的智械導師。\n“當初撿你不如撿塊廢鐵！”——莫托經常對他的養子賓這麼說。",
    "moto_introduction_2": "衝鋒陷陣的暴戾統領，以爆制暴的戰爭機器。\n“據說這位可敬的矮人曾在爆炸中失去下頜，不知他面罩上的鬍子從何而來。”",
    "carino_before": "聖槍",
    "carino": "卡里諾",
    "carino_skill_1": "榮光遊俠",
    "carino_skill_2": "致命掠影",
    "carino_skill_3": "戰火狂徒",
    "carino_introduction_1": "恪守正義的貴族遊俠，槍法卓絕的彈藥專家。\n“卡里諾小時候總是哭著叫我叔叔的。歲月不饒人啊！”——尤加的閒暇感喟。",
    "carino_introduction_2": "身負罪惡的弒君之人，遊走黑暗的致命獵手。\n“換彈是槍手最脆弱的時刻，但他不一樣。”",
    "carino_introduction_3": "毀滅一切的戰爭兵器，引燃戰火的末路狂徒。\n「黑隘口的戰火不會停止，就像狂徒在自我締造的戰爭中窮極一生。」",
    "rehan_before": "狂人",
    "rehan": "雷恩",
    "rehan_skill_1": "怒火",
    "rehan_skill_2": "怒靈",
    "rehan_skill_3": "怒風",
    "rehan_introduction_1": "將怒氣化為力量的蠻族戰士，在與敵人的不斷戰鬥中積攢怒火，愈戰愈勇。\n雷恩非常喜歡唱歌。據說在災燼毀滅他的家園之前，他曾經計劃在雪原上開巡迴演唱會。",
    "rehan_introduction_2": "將怒氣奉獻給祖靈換取護佑的蠻族戰士，與瓦拉岡的先祖並肩作戰。\n雷恩其實很緊張自己小時候偷先祖之谷裡供品吃的時候，是不是也被祖靈看在眼裡。",
    "gemma_before": "冰燄",
    "gemma": "吉瑪",
    "gemma_skill_1": "冰火融合",
    "gemma_skill_2": "冰結之心",
    "gemma_skill_3": "烈焰形態",
    "gemma_skill_4": "歡愉之焰",
    "gemma_introduction_1": "冰火交融的雙重靈魂，相伴相生的烈焰寒冰。\n“聽吉瑪的心聲吵架並作出點評，是希雅每天的保留節目。”",
    "gemma_introduction_2": "風雪之間的孤獨靈魂，溫馴刺骨的不化寒冰。\n“艾瑞卡，把你沒吃完的老鼠從我床上拿走。我不會保鮮。”",
    "gemma_introduction_4": "浴火狂宴極樂無盡，裙下愚臣癡纏未休。\n「來嘛，讓我嚐嚐你痛苦的味道。」",
    "youga_before": "時空見證者",
    "youga": "尤加",
    "youga_skill_1": "時空幻象",
    "youga_skill_2": "時空流逝",
    "youga_skill_3": "時空見證",
    "youga_introduction_1": "我可是科技與魔法的完美結合，時間和空間的得意寵兒，火炬之光的中流砥柱！\n“嘿！我才是本體！別信上面的假貨！”——幻象尤加",
    "youga_introduction_2": "我以為在時間亂流中粉身碎骨已經是最糟糕的事情，可更淒慘的事實是——這片時空亂流賴在我身上不走了！\n“我纏上這身繃帶，就是想看那群物理學家為了底下的我是否活著爭來爭去。”",
    "thea_before": "神諭者",
    "thea": "希雅",
    "thea_skill_1": "眾神之偉智",
    "thea_skill_2": "眾神之化身",
    "thea_skill_3": "瀆神",
    "thea_introduction_1": "受到六神祝福的神諭者，運用神的祝福預言未來，施展神罰。\n“讓六神的教誨，為你指引方向。”",
    "thea_introduction_2": "匯聚眾神偉力，再現神域天國。\n“凡我所行之事，皆為神之諭意。”",
    "thea_introduction_3": "聽到第七個人為同一種罪孽告解，我忽然明白──我們只是在用不同的語言重複同一種潰爛。",
    "comming": "敬請期待",
    "erika_before": "貓眼",
    "erika": "艾瑞卡",
    "erika_skill_1": "疾風追獵",
    "erika_skill_2": "電光貓影",
    "erika_skill_3": "",
    "erika_introduction_1": "如疾風一般的貓耳少女，精通追捕的狩獵大師。\n“嘿嘿，我可是跑得比閃電還快的艾瑞卡！”",
    "erika_introduction_2": "擔任首席閃電研究員的艾瑞卡，在霹靂啪啦的奇妙電光間把敵人通通消滅！\n「只要艾瑞卡還在奔跑，火炬之光就永遠不會斷電！」",
    "bing_before": "逃脫者",
    "bing": "賓",
    "bing_skill_1": "爆破新星",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "轟轟烈烈的爆破藝術家，樂於奔命的麻煩製造者。\n“因為向雷恩成功推銷褲衩型爆彈，一舉成名。”",
    "iris_before": "遺世魔靈",
    "iris": "伊瑞斯",
    "iris_skill_1": "生長的微風",
    "iris_skill_2": "守望的暖風",
    "iris_introduction_1": "魔靈小隊的親密夥伴，努力生長的徐徐微風。\n「我們在成長，如這世間的萬物。」",
    "iris_introduction_2": "魔靈背後的溫柔守望，輕拂萬物的和煦暖風。\n「我們正在編織一陣守護世界的暖風。」",
    "rosa_before": "光曜",
    "rosa": "羅莎",
    "rosa_skill_1": "聖庭戰車",
    "rosa_introduction_1": "聖德蘭不守規矩的見習騎士，戰場上一往無前的聖庭戰車。「聖靈會寬恕你們，而我會送你們去見聖靈。」",
    "selena_before": "汐語",
    "selena": "賽琳娜",
    "selena_skill_1": "與海潮同歌",
    "selena_introduction_1": "讓海潮輕擁大地，讓歌聲響徹心靈。\n「從今之後，我只為自己而歌」",
    "intro_title": "概述"
  },
  kr: {
    "moto_before": "지휘관",
    "moto": "모토",
    "moto_skill_1": "소집 명령",
    "moto_skill_2": "돌격 소집",
    "moto_skill_3": "연합 소집",
    "moto_introduction_1": "정예 부대를 통솔하는 제국의 장군, 엠버를 탐구하는 스마트 웨폰의 멘토\n'애초에 넌 고철만도 못했어!'-모토가 양자 빈에게 자주 하는 말",
    "moto_introduction_2": "포악한 대장, 적진에 돌진하여 폭발하라.\n'이 위대하신 드워프께서 폭발로 턱을 잃으셨다는데, 가면에 붙은 이 수염은 도대체 뭘까.'",
    "carino": "카리노",
    "carino_before": "디바인 샷",
    "carino_skill_1": "영광의 레인저",
    "carino_skill_2": "치명적 찰나",
    "carino_skill_3": "전쟁 광인",
    "carino_introduction_1": "정의를 수호하는 귀족 레인저, 탁월한 사격 실력의 탄약 전문가\n'꼬맹이 카리노, 늘 날 삼촌이라고 부르며 칭얼댔지. 아, 세월이여!' -유가의 탄식",
    "carino_introduction_2": "폭군 시해자, 어둠을 헤엄쳐 간 위험한 사냥꾼.\n'거너의 약점은 탄창을 교체하는 순간이야. 하지만 그는 다르지.'",
    "carino_introduction_3": "모든 것을 파멸해버리는 인간병기, 전쟁에 미친 광인.\n'끝없은 전쟁 속에서 광인은 자기의 존재를 찾는다.'",
    "rehan": "리한",
    "rehan_before": "버서커",
    "rehan_skill_1": "타오르는 분노",
    "rehan_skill_2": "분노의 정령",
    "rehan_skill_3": "분노의 바람",
    "rehan_introduction_1": "분노를 힘으로 바꾼 야만족 전사, 적과의 전투에서 쌓아 올린 분노의 불꽃으로 점점 더 용맹해진다.\n리한은 노래 부르는 걸 좋아한다. 디스엠버가 그의 고향을 파멸시키기 전, 설원 순회 콘서트를 계획했을 정도로.",
    "rehan_introduction_2": "와라곤의 전사, 조상에게 분노를 바치고 그들과 함께 싸우다.\n사실 어릴 때 제사 음식을 훔쳐먹은 적이 있는 리한은 조상의 눈 밖에 나지 않았을까 전전긍긍하고 있다.",
    "gemma_before": "빙염술사",
    "gemma": "젬마",
    "gemma_skill_1": "빙화 융합",
    "gemma_skill_2": "프로즌 하트",
    "gemma_skill_3": "화염 형태",
    "gemma_skill_4": "향락의 불꽃",
    "gemma_introduction_1": "얼음과 불의 융합, 화염과 얼음이 상생하는 영혼.\n'티아의 일과: 젬마의 마음속에서 일어나는 싸움을 듣고 심판하기.'",
    "gemma_introduction_2": "녹지 않는 얼음에 완벽히 길들여진 눈보라 속의 고독한 영혼.\n'에리카, 먹다 남긴 쥐 좀 치워줄래? 나 냉장고 아니거든.'",
    "gemma_introduction_4": "화염속 광란으로 무궁무진한 향락을 누리고 치마 밑 어리 석은 신하들은 끊임없이 집착한다.\n'이리 와, 너의 고통을 맛보여줘'",
    "youga": "유가",
    "youga_before": "시공간의 증인",
    "youga_skill_1": "시공간의 환상",
    "youga_skill_2": "시공 유실",
    "youga_skill_3": "시공간의 증거",
    "youga_introduction_1": "이 몸은 기술과 마법의 완벽한 결합, 시간과 공간을 지배하는 풍운아, 토치라이트의 기둥이시다!\n'핫! 내가 진짜라고! 가짜에 속지 말 것!' -유가의 환상",
    "youga_introduction_2": "혼돈의 시간 속에서 몸이 부서지는 게 최악이라고 생각했는데, 사실 더 최악은 이 혼돈의 시공간이 내게서 떨어지지 않는다는 거였어! \n'내가 붕대를 감은 이유는 바로 저 물리학자들이 내 생사를 두고 다투는 걸 구경하기 위해서라고.'",
    "thea_before": "사제",
    "thea": "티아",
    "thea_skill_1": "신들의 위대한 지혜",
    "thea_skill_2": "신들의 화신",
    "thea_skill_3": "모독된 신성",
    "thea_introduction_1": "여섯 신의 축복을 받은 사제, 신들의 축복으로 미래를 예언하고 형벌을 내린다.\n'여섯 신의 가르침이 그대를 인도하리.'",
    "thea_introduction_2": "신들의 힘을 결집해 신의 영역인 천국을 재현한다.\n내가 하는 모든 일은 신의 뜻이다.",
    "thea_introduction_3": "일곱 번째 사람이 같은 죄를 고백하는 순간, 깨달았다. \n우리는 그저 서로 다른 언어로 같은 부패를 되풀이하고 있을 뿐이라는 것을.",
    "comming": "Coming Soon",
    "erika_before": "캣츠아이",
    "erika": "에리카",
    "erika_skill_1": "질풍 추격",
    "erika_skill_2": "라이트닝 쉐도우",
    "erika_skill_3": "",
    "erika_introduction_1": "고양이 귀를 가진 소녀는 질풍처럼 빠르고 추격에 능한 사냥의 대가이다.\n'히히, 번개보다 빠른 에리카다옹!'",
    "erika_introduction_2": "수석 라이트닝 연구원 - 에리카 참전! 터지는 불빛 사이를 가로질러 적들을 모조리 해치워 버릴 거예요!\n'에리카만 달려준다면 토치라이트의 빛은 영원히 꺼지지 않을 것입니다!'",
    "bing_before": "도망자",
    "bing": "빈",
    "bing_skill_1": "블래스트 노바",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "요란한 폭발 예술가, 워커 홀릭 트러블 메이커.\n'리한에게 팬티 폭탄을 파는 데 성공해 유명세를 탔지.'",
    "iris_before": "속세를 떠난 마령",
    "iris": "아이리스",
    "iris_skill_1": "성장의 미풍",
    "iris_skill_2": "수호의 온풍",
    "iris_introduction_1": "마령 소대의 친밀한 동료, 열심히 노력해서 성장하는 미풍.\n'우리는 성장하고 있어, 세상의 만물처럼.'",
    "iris_introduction_2": "마령 뒤에 따스한 시선, 만물을 어루만지는 온화한 바람.\n\"우리는 지금 온 세상을 품을수 있는 따스한 바람을 만들고 있습니다.\"",
    "rosa_before": "라이트 브링어",
    "rosa": "로사",
    "rosa_skill_1": "홀리 채리엇",
    "rosa_introduction_1": "성덕란의 규칙을 어기는 견습 기사, 전장에서 무모한 성정 전차. \"성령이 여러분을 용서해 줄 것이고, 나는 여러분을 성령 앞으로 보내 줄 것입니다.\"",
    "selena_before": "파도의 숨결",
    "selena": "셀레나",
    "selena_skill_1": "파도와 함께하는 노래",
    "selena_introduction_1": "파도가 대지를 부드럽게 감싸고 아름다운 노래로 마음을 치유.\n'이제부터 나는 나만을 위해 노래해'",
    "intro_title": "소개"
  },
  cn: {
    "moto_before": "指挥官",
    "moto": "莫托",
    "moto_skill_1": "号令征召",
    "moto_skill_2": "冲锋征召",
    "moto_skill_3": "联合征召",
    "moto_introduction_1": "统率劲旅的帝国将军，精研灰烬的智械导师。\n“当初捡你不如捡块废铁！”——莫托经常对他的养子宾这么说。",
    "moto_introduction_2": "冲锋陷阵的暴戾统领，以爆制暴的战争机器。\n“据说这位可敬的矮人曾在爆炸中失去下颌，不知他面罩上的胡子从何而来。”",
    "carino_before": "圣枪",
    "carino": "卡里诺",
    "carino_skill_1": "荣光游侠",
    "carino_skill_2": "致命掠影",
    "carino_skill_3": "战火狂徒",
    "carino_introduction_1": "恪守正义的贵族游侠，枪法卓绝的弹药专家。\n“卡里诺小时候总是哭着叫我叔叔的。岁月不饶人啊！”——尤加的闲暇感喟。",
    "carino_introduction_2": "身负罪恶的弑君之人，游走黑暗的致命猎手。\n“换弹是枪手最脆弱的时刻，但他不一样。”",
    "carino_introduction_3": "毁灭一切的战争兵器，引燃战火的末路狂徒。\n“黑隘口的战火不会停止，就像狂徒在自我缔造的战争中穷极一生。”",
    "rehan_before": "狂人",
    "rehan": "雷恩",
    "rehan_skill_1": "怒火",
    "rehan_skill_2": "怒影",
    "rehan_skill_3": "怒风",
    "rehan_introduction_1": "将怒气化为力量的蛮族战士，在与敌人的不断战斗中积攒怒火，愈战愈勇。\n雷恩非常喜欢唱歌。据说在灾烬毁灭他的家园之前，他曾经计划在雪原上开巡回演唱会。",
    "rehan_introduction_2": "将怒气奉献给祖灵换取护佑的蛮族战士，与瓦拉冈的先祖并肩作战。\n雷恩其实很紧张自己小时候偷先祖之谷里供品吃的时候，是不是也被祖灵看在眼里。",
    "gemma_before": "冰焰",
    "gemma": "吉玛",
    "gemma_skill_1": "冰火融合",
    "gemma_skill_2": "冰结之心",
    "gemma_skill_3": "烈焰形态",
    "gemma_skill_4": "欢愉之焰",
    "gemma_introduction_1": "冰火交融的双重灵魂，相伴相生的烈焰寒冰。\n“听吉玛的心声吵架并作出点评，是希雅每天的保留节目。”",
    "gemma_introduction_2": "风雪之间的孤独灵魂，温驯刺骨的不化寒冰。\n“艾瑞卡，把你没吃完的老鼠从我床上拿走。我不会保鲜。”",
    "gemma_introduction_4": "浴火狂宴极乐无尽，裙下愚臣痴缠未休\n“来嘛，让我尝尝你痛苦的味道。”",
    "youga_before": "时空见证者",
    "youga": "尤加",
    "youga_skill_1": "时空幻象",
    "youga_skill_2": "时空流逝",
    "youga_skill_3": "时空见证",
    "youga_introduction_1": "我可是科技与魔法的完美结合，时间和空间的得意宠儿，火炬之光的中流砥柱！\n“嘿！我才是本体！别信上面的假货！”——幻象尤加",
    "youga_introduction_2": "我以为在时间乱流中粉身碎骨已经是最糟糕的事情，可更凄惨的事实是——这片时空乱流赖在我身上不走了！\n“我缠上这身绷带，就是想看那群物理学家为了底下的我是否活着争来争去。”",
    "thea_before": "神谕者",
    "thea": "希雅",
    "thea_skill_1": "众神之伟智",
    "thea_skill_2": "众神之化身",
    "thea_skill_3": "渎神",
    "thea_introduction_1": "受到六神祝福的神谕者，运用神的祝福预言未来，施展神罚。\n“让六神的教诲，为你指引方向。”",
    "thea_introduction_2": "汇聚众神伟力，再现神域天国。\n“凡我所行之事，皆为神之谕意。”",
    "thea_introduction_3": "听到第七个人为同一种罪孽告解，我忽然明白——我们只是在用不同的语言重复同一种溃烂。",
    "erika_before": "猫眼",
    "erika": "艾瑞卡",
    "erika_skill_1": "疾风追猎",
    "erika_skill_2": "电光猫影",
    "erika_skill_3": "",
    "erika_introduction_1": "如疾风一般的猫耳少女，精通追捕的狩猎大师。\n“嘿嘿，我可是跑得比闪电还快的艾瑞卡！”",
    "erika_introduction_2": "担任首席闪电研究员的艾瑞卡，在噼里啪啦的奇妙电光间把敌人统统消灭！\n“只要艾瑞卡还在奔跑，火炬之光就永远不会断电！”",
    "bing_before": "逃脱者",
    "bing": "宾",
    "bing_skill_1": "爆破新星",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "轰轰烈烈的爆破艺术家，乐于奔命的麻烦制造者。\n“因为向雷恩成功推销裤衩型爆弹，一举成名。”",
    "iris_before": "遗世魔灵",
    "iris": "伊瑞斯",
    "iris_skill_1": "生长的微风",
    "iris_skill_2": "守望的暖风",
    "iris_introduction_1": "魔灵小队的亲密伙伴，努力生长的徐徐微风。\n“我们在成长，如这世间的万物。”",
    "iris_introduction_2": "魔灵背后的温柔守望，轻拂万物的和煦暖风。\n“我们正在编织一阵守护世界的暖风。”",
    "rosa_before": "光曜",
    "rosa": "罗莎",
    "rosa_skill_1": "圣庭战车",
    "rosa_introduction_1": "圣德兰不守规矩的见习骑士，战场上一往无前的圣庭战车。“圣灵会宽恕你们，而我会送你们去见圣灵。”",
    "selena_before": "汐语",
    "selena": "赛琳娜",
    "selena_skill_1": "与海潮同歌",
    "selena_introduction_1": "让海潮轻拥大地，让歌声响彻心灵。\n“从今之后，我只为自己而歌。”",
    "intro_title": "简介"
  },
  jp: {
    "moto_before": "コマンダー",
    "moto": "モート",
    "moto_skill_1": "召集命令",
    "moto_skill_2": "突撃召集",
    "moto_skill_3": "連合召集",
    "moto_introduction_1": "強大な軍隊を率いる帝国の将軍、エンバーに精通したAI教官\n「お前じゃなくクズ鉄を拾えばよかったよ！」——養子のピンは常にモートからそう言われていました。",
    "moto_introduction_2": "突撃戦法を駆使する凶暴な指揮官、爆発で暴力を制する戦争兵器\n「あの偉大なドワーフは爆発で下顎を失ったそうだが、マスクの上のひげの由来は謎のままだ」",
    "carino": "カリーノ",
    "carino_before": "ディバインショット",
    "carino_skill_1": "ネクロスナップ",
    "carino_skill_2": "グローリーレンジャー",
    "carino_skill_3": "烈火の無法者",
    "carino_introduction_1": "正義を守る貴族のレンジャー、射撃技術に長けた弾薬のエキスパート\n「カリーノは子供の頃、いつも泣きながら俺の名を呼んでいたよ。時の流れを感じるよね」——ユーガのつぶやき",
    "carino_introduction_2": "王殺しの罪を負い、闇を遊走する死のハンター\n「再装填時がガンマンの弱点。だが彼は違う」",
    "carino_introduction_3": "すべてを破壊する戦争兵器、戦火を引き起こす烈火の無法者。\n「黒い隘口の戦火は止まらない、まるで狂信者が自ら築き上げた戦争の中で一生懸命になるかのように。」",
    "rehan": "リーハン",
    "rehan_before": "バーサーカー",
    "rehan_skill_1": "怒りの炎",
    "rehan_skill_2": "レイジングシャドウ",
    "rehan_skill_3": "怒りの風",
    "rehan_introduction_1": "怒りを力に変えた蛮族の戦士。敵との戦いの中で怒りを溜め、戦うほどに勇猛さを増す\nリーハンは歌うことが大好きです。ルインが彼の故郷を破壊する前、雪原でのコンサートツアーを計画していたとか……",
    "rehan_introduction_2": "怒りを祖霊に捧げて加護を受け、バラカンの先祖と共に戦う蛮族の戦士\n実はリーハンには気がかりがあります。子供の頃に先祖の谷の供物を盗んで食べた時、祖霊に見られていたのではと……",
    "gemma_before": "フロストファイア",
    "gemma": "ジェマ",
    "gemma_skill_1": "フレイム形態",
    "gemma_skill_2": "氷結の心",
    "gemma_skill_3": "氷火融合",
    "gemma_skill_4": "悦楽の炎",
    "gemma_introduction_1": "氷と火が融合する重なり合う魂、共生する炎と氷\n「ジェマの心中の争いを聞いてコメントすることがシーアの日課」",
    "gemma_introduction_2": "風雪の間の孤独な魂、温もりにも溶けない氷\n「エリカ、食べかけのマウスを私のベッドに置かないで。私に冷凍保存は無理！」",
    "gemma_introduction_4": "炎に包まれた狂宴の極楽が絶え間なく、スカートの下に愚かな臣下が執拗に絡みつく。\n「さあ、あなたの苦しみを味わわせてちょうだい。」",
    "youga": "ユーガ",
    "youga_before": "時空の証人",
    "youga_skill_1": "時空イリュージョン",
    "youga_skill_2": "時空の証人",
    "youga_skill_3": "時空スリップ",
    "youga_introduction_1": "テクノロジーと魔法の完璧な融合者、時空の寵児、俺こそトーチライトの大黒柱だ！\n「ヘイ！こっちが本体だ！あっちのニセ者に騙されるなよ！」——ミラージュ・ユーガ",
    "youga_introduction_2": "時間の乱れの中で粉々にされるのが最悪だと思っていたんだが、さらに悲惨なことが俺の身に……時空の乱れに取りつかれちまった！\n「この包帯を巻いている理由？中身の俺が生きているかを物理学者どもが論争するのを眺めるためさ」",
    "thea_before": "オラクル",
    "thea": "シーア",
    "thea_skill_1": "神々の英知",
    "thea_skill_2": "神々の化身",
    "thea_skill_3": "",
    "thea_introduction_1": "六神の祝福を得たオラクルは神の祝福を用いて未来を予言し、神罰を下す\n「六神の教えがあなたを導くでしょう」",
    "thea_introduction_2": "神々の偉大な力を集め、神の領域を再現\n「我がなす事はすべて神の意志！」",
    "comming": "COMING SOON",
    "erika_before": "キャッツアイ",
    "erika": "エリカ",
    "erika_skill_1": "ウインドチェイサー",
    "erika_skill_2": "キャットシャドウ",
    "erika_skill_3": "",
    "erika_introduction_1": "風のように素早い猫耳の少女、追跡が得意な狩りの名手\n「イェ～イ、私はイナヅマより速く走れるエリカだよ！」",
    "erika_introduction_2": "「雷」の主任研究員、エリカがチカチカする不思議な電光の中で敵をすべて消し去ります！\n「エリカが走り続ける限り、トーチライトは永遠に停電しない！」",
    "bing_before": "脱走者",
    "bing": "ピン",
    "bing_skill_1": "ブラストノバ",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "破天荒な爆破アーティスト、命すら惜しまないトラブルメーカー\n「リーハンに下着爆弾を売り一躍有名に！」",
    "iris_before": "見捨てられし魔霊",
    "iris": "イレーズ",
    "iris_skill_1": "成長の微風",
    "iris_skill_2": "守望の温風",
    "iris_introduction_1": "魔霊小隊の親密な仲間、努力して成長する微風。\n「私たちは成長している、この世界のすべてのものと同じように。」",
    "iris_introduction_2": "魔物を見守り、世界を包み込む温かい風。 \n「私たちは、世界を包む温かい風を紡いでいる。」",
    "rosa_before": "ブライト",
    "rosa": "ローザ",
    "rosa_skill_1": "聖域の戦車",
    "rosa_introduction_1": "サントランの破天荒な見習い騎士で、戦場での突撃を恐れない聖庭の戦車。「聖霊はあなたたちを許してくれる、私があなたたちを聖霊のもとへ送ります。」",
    "selena_before": "汐の依代",
    "selena": "セレーナ",
    "selena_skill_1": "海潮と歌う",
    "selena_introduction_1": "潮が大地を優しく包み、歌声が心に響き渡る。\n「これからは、自分のために歌おう。」",
    "intro_title": "简介"
  },
  th: {
    "moto_before": "ผู้บัญชาการ",
    "moto": "โมโท",
    "moto_skill_1": "ประกาศแต่งตั้ง",
    "moto_skill_2": "แต่งตั้งแนวรุก",
    "moto_skill_3": "",
    "moto_introduction_1": "นายพลจักรวรรดิผู้บัญชาการกองทัพที่ทรงพลังและที่ปรึกษากลไกในการศึกษาซินเดอร์\n“ตอนแรกที่เก็บเจ้าสู้เก็บเศษเหล็กดีกว่า!\"--โมโทมักจะพูดแบบนี้กับปินลูกชายบุญธรรมของเขา“",
    "moto_introduction_2": "ผู้นําหัวรุนแรงที่เข้าสู่วงล้อมแนวหน้า ใช้เครื่องจักรสงครามที่ต่อสู้ที่ควบคุมความรุนแรงด้วยการระเบิด\n“ว่ากันว่าคนแคระที่น่าเคารพตนนี้เคยสูญเสียกรามของเขาในการระเบิด ไม่รู้ว่าเคราบนหน้ากากของเขามาจากไหน“",
    "carino_before": "หอกศักดิ์สิทธิ์",
    "carino": "คาริโน",
    "carino_skill_1": "หน่วยพิทักษ์ความรุ่งโรจน์",
    "carino_skill_2": "เงามรณะ",
    "carino_skill_3": "",
    "carino_introduction_1": "เรนเจอร์ชนชั้นสูงที่ชอบธรรม ผู้เชี่ยวชาญด้านกระสุนที่มีฝีมือปืนที่ยอดเยี่ยม\n“คาริโนมักจะร้องไห้และเรียกข้าว่าลุง กาลเวลาช่างไม่รอใครเสียจริง!“--ความรู้สึกสบายๆ ของยูกะ",
    "carino_introduction_2": "บาปแห่งฆาตกร นักล่ามฤตยูที่เดินผ่านความมืด\n“การเปลี่ยนกระสุนเป็นช่วงเวลาที่เปราะบางที่สุดของมือปืน แต่เขาต่างออกไป”",
    "rehan_before": "ผู้บ้าคลั่ง",
    "rehan": "รีฮาน",
    "rehan_skill_1": "ความโกรธ",
    "rehan_skill_2": "เงาโกรธ",
    "rehan_skill_3": "",
    "rehan_introduction_1": "นักรบป่าเถื่อนที่เปลี่ยนความโกรธเป็นพลัง ได้ทำการสั่งสมความโกรธในการต่อสู้กับศัตรูอย่างต่อเนื่อง ยิ่งรบยิ่งกล้ามากขึ้นเรื่อยๆ\nรีฮานชอบร้องเพลงมาก ว่ากันว่าก่อนที่แอมเบอร์ทําลายบ้านของเขา เขาเคยวางแผนที่จะไปทัวร์คอนเสิร์ตในทุ่งหิมะ",
    "rehan_introduction_2": "นักรบป่าเถื่อนที่ถวายความโกรธให้กับวิญญาณบรรพบุรุษเพื่อแลกกับการปกป้อง และการต่อสู้เคียงข้างบรรพบุรุษของวาลากอร์น\nรีฮานรู้สึกประหม่ามากเมื่อตอนที่ยังเด็กเขาได้ขโมยเครื่องเซ่นไหว้ในหุบเขาของบรรพบุรุษมากิน โดนวิญญาณบรรพบุรุษเห็นกับตาใช่หรือไม่",
    "gemma_before": "เจ็มม่า",
    "gemma": "ไฟหิมะ",
    "gemma_skill_1": "การหลอมเหลวน้ำแข็งและไฟ",
    "gemma_skill_2": "หัวใจแช่แข็ง",
    "gemma_skill_3": "",
    "gemma_skill_4": "เปลวไฟแห่งความสุข",
    "gemma_introduction_1": "วิญญาณคู่ของน้ําแข็งและไฟที่ผสมเข้าด้วยกัน เปลวไฟและน้ําแข็งที่อยู่คู่มาด้วยกัน\n“ฟังเสียงทะเลาะวิวาทในใจของเจ็มม่าและแสดงความคิดเห็น เป็นรายการประจําวันของเธีย”",
    "gemma_introduction_2": "วิญญาณที่โดดเดี่ยวระหว่างลมและหิมะ การเจาะทะลุของน้ําแข็งที่ไม่ละลาย\n“เอริก้า พาหนูที่ยังกินไม่เสร็จของเจ้าออกจากเตียงของข้า ข้าจะไม่ทําให้มันสด”",
    "gemma_introduction_4": "เทศกาลไฟลุกสุดประหาร ความสุขไม่รู้จบ \nข้ารองที่ยังคงหลงไหล \"มาเถอะ \nให้ฉันชิมรสของความทุกข์ของคุณ\"",
    "youga_before": "พยานแห่งกาลอวกาศ",
    "youga": "โยวก้า",
    "youga_skill_1": "ภาพลวงต่างมิติ",
    "youga_skill_2": "กาลเวลาที่ย้อนกลับ",
    "youga_skill_3": "",
    "youga_introduction_1": "ข้าเป็นการผสมผสานที่ลงตัวระหว่างเทคโนโลยีและเวทมนตร์ ความภาคภูมิใจของเวลาและช่องว่าง แกนของTorchlight!\n“เหอะ! ข้าดำรงอยู่ด้วยตัวข้าเอง! อย่าเชื่อในของปลอมด้านบน!“--แฟนทอมยูกะ",
    "youga_introduction_2": "ข้าคิดว่าการถูกบดขยี้เป็นชิ้นเล็กชิ้นน้อยในความปั่นป่วนของเวลานั้นเป็นสิ่งที่เลวร้ายที่สุดแล้ว แต่ความจริงที่น่าเศร้ากว่านั้นก็คือ--กาลเวลาที่ย้อนกลับนี้อยู่ติดกับข้าไม่ไปไหนเลย!\n“ข้าสวมใส่ผ้าพันแผลนี้ เพื่อดูว่านักฟิสิกส์กลุ่มนั้นต่อสู้กันเพื่อให้ข้ามีชีวิตอยู่ต่อ”",
    "thea_before": "ออราเคิล",
    "thea": "เธีย",
    "thea_skill_1": "ปัญญาของเหล่าเทพเจ้า",
    "thea_skill_2": "อวตารของเทพเจ้า",
    "thea_skill_3": "",
    "thea_introduction_1": "ออราเคิลที่ได้รับพรจากเทพเจ้าทั้งหก ใช้พรของเทพเจ้าเพื่อทํานายอนาคต และแสดงการลงโทษจากสวรรค์\n“ให้คําสอนของเทพเจ้าทั้งหก นําทางให้กับเจ้า”",
    "thea_introduction_2": "รวบรวมพลังอันยิ่งใหญ่ของเหล่าเทพเจ้า และปรากฏขึ้นในดินแดนเทพเจ้าของอาณาจักรสวรรค์\n“ทุกสิ่งที่ข้าทําคือพระบัญญัติของเทพเจ้า”",
    "erika_before": "เนตรแมว",
    "erika": "เอริก้า",
    "erika_skill_1": "นักล่าลมกรด",
    "erika_skill_2": "เงาแมวไฟฟ้า",
    "erika_skill_3": "",
    "erika_introduction_1": "สาวหูแมวเหมือนดั่งลมกรด นักล่าระดับปรมาจารย์ที่เชี่ยวชาญในการล่าสัตว์\n“เหอะๆ ข้าคือเอริก้าที่วิ่งเร็วกว่าสายฟ้า!”",
    "erika_introduction_2": "เอริกาที่ดำรงตำแหน่งหัวหน้านักวิจัยสายฟ้า สามารถกำจัดศัตรูทั้งหมดในความแปลกประหลาดของแสงไฟฟ้าที่ประหยัด!\n'ตราบใดที่เอริกายังวิ่งอยู่ ไฟฟ้าของ Torchlight จะไม่หยุดสาย!'",
    "bing_before": "ผู้หลบหลีก",
    "bing": "ทหาร",
    "bing_skill_1": "ระเบิดโนวา",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "ศิลปินระเบิดพลัง ผู้ก่อปัญหาที่มีวิ่งอย่างเร็วที่สุด\n“เนื่องจากประสบความสําเร็จในการขายระเบิดแบบกางเกงให้กับรีฮาน จึงได้รับชื่อเสียงในคราวเดียว”",
    "iris_before": "มรดกวิญญาณมอนสเตอร์",
    "iris": "ไอริส",
    "iris_skill_1": "สายลมที่ เติบโต",
    "iris_skill_2": "",
    "iris_introduction_1": "มอนสเตอร์เป็นเพื่อนสนิทของกลุ่มฮีโร่ \nพวกเขาเติบโตเป็นสายลมอ่อนๆ\"เรากำลังเติบโต \nเหมือนทุกสิ่งในโลกนี้\"",
    "iris_introduction_2": "",
    "rosa_before": "แสงอาทิตย์",
    "rosa": "โรซ่า",
    "rosa_skill_1": "รถม้าของวัดศักดิ์สิทธิ์",
    "rosa_introduction_1": "นักศึกษานักอัศวินที่ไม่ปฏิบัติตามกฎของเซนต์เดอลัน รถยุทธภัณฑ์ของศาลาศักดิ์สิทธิ์ที่ก้าวหน้าไปต่อหน้าในสนามรบ \"วิญญาณบริสุทธิ์จะอภัยให้คุณ และฉันจะส่งคุณไปพบวิญญาณบริสุทธิ์\"",
    "selena_before": "",
    "selena": "",
    "selena_skill_1": "",
    "selena_introduction_1": "",
    "intro_title": "บทนำ"
  },
  id: {
    "moto_before": "Komandan",
    "moto": "Moto",
    "moto_skill_1": "Panggilan instruksi",
    "moto_skill_2": "Perintah penyerangan",
    "moto_skill_3": "",
    "moto_introduction_1": "Jenderal Kekaisaran yang memimpin pasukan yang kuat, serta Master Mekanik Cerdas yang meneliti bara secara khusus.\n“Lebih baik mengambil sepotong besi tua daripada menjemputmu saat itu!”--Moto sering berkata kepada putra angkatnya, Bean.",
    "moto_introduction_2": "Pemimpin yang ganas menyerbu ke dalam pertempuran, menggunakan mesin perang eksplosif untuk menekan kekerasan.\n“Dikatakan bahwa kurcaci terhormat ini pernah kehilangan rahangnya dalam ledakan, dan aku tidak tahu dari mana asal jenggot di topengnya.",
    "carino_before": "Penembak sakti",
    "carino": "Carino",
    "carino_skill_1": "Pasukan kemuliaan",
    "carino_skill_2": "Sekilas mematikan",
    "carino_skill_3": "",
    "carino_introduction_1": "Penjaga mulia yang menjunjung keadilan, juga seorang ahli amunisi dengan kemampuan menembak yang sangat baik.\n“Saat masih kecil Carino selalu menangis dan memanggilku paman. Waktu berlalu dengan cepat ya!“--Hela napas Yuga di waktu luangnya.",
    "carino_introduction_2": "Pembantaian yang jahat, pemburu mematikan yang berkeliaran di kegelapan.\n“Mengganti peluru adalah momen paling rentan bagi penembak, tapi dia berbeda.”",
    "rehan_before": "Maniak",
    "rehan": "Rehan",
    "rehan_skill_1": "Amarah",
    "rehan_skill_2": "Bayangan Kemarahan",
    "rehan_skill_3": "",
    "rehan_introduction_1": "Prajurit barbar yang mengubah amarah mereka menjadi kekuatan, menumpuk amarah dalam pertempuran terus-menerus dengan musuh, dan menjadi semakin berani saat bertarung.\nRehan sangat suka bernyanyi. Dikatakan bahwa sebelum bara menghancurkan rumahnya, dia pernah berencana untuk mengadakan tur konser di padang salju.",
    "rehan_introduction_2": "Prajurit barbar yang mengorbankan amarahnya pada roh leluhur dengan imbalan perlindungan, bertarung bersama dengan leluhur Valragorn.\nSebenarnya Rehan sangat gugup apakah dia juga ketahuan oleh Roh Leluhur ketika dia mencuri persembahan dari Lembah Leluhur ketika dia masih kecil.",
    "gemma_before": "Api es",
    "gemma": "Gema",
    "gemma_skill_1": "Perpaduan Api dan Es",
    "gemma_skill_2": "Hati yang Beku",
    "gemma_skill_3": "",
    "gemma_skill_4": "Api Kegembiraan",
    "gemma_introduction_1": "Jiwa ganda dari perpaduan es dan api, disertai dengan nyala api dan es yang dingin.\n“Mendengarkan perdebatan suara hati Gemma dan berkomentar, merupakan rutinitas harian Thea.”",
    "gemma_introduction_2": "Jiwa yang kesepian di antara angin dan salju, lembut dan menusuk, tidak mencairkan es yang dingin.\n“Erika, bawa pergi tikus yang belum selesai kamu makan dari tempat tidurku. Aku tidak bisa menjaganya tetap segar.”",
    "gemma_introduction_4": "Pesta liar yang tak berkesudahan di tengah \nkobaran api, bawahan bodoh yang terus menerus \ntergila-gila di bawah rok \"Ayo, biarkan aku merasakan rasa sakitmu.\"",
    "youga_before": "Pengatur ruang waktu",
    "youga": "Yuga",
    "youga_skill_1": "Ilusi Ruang dan Waktu",
    "youga_skill_2": "Waktu dan Ruang Berlalu",
    "youga_skill_3": "",
    "youga_introduction_1": "Aku adalah kombinasi sempurna antara teknologi dan sihir, kebanggaan ruang dan waktu, serta andalannya Torchlight!\n“Hei! Akulah yang asli! Jangan percaya dengan benda palsu di atas!“--Ilusi Yuga",
    "youga_introduction_2": "Kupikir hancur dalam turbulensi waktu sudah merupakan hal terburuk, tetapi fakta yang lebih tragis adalah--Turbulensi waktu dan ruang yang kacau ini bergantung padaku dan tidak akan pergi!\n“Aku mengenakan perban ini hanya untuk melihat apakah para fisikawan itu berdebat tentang apakah aku masih hidup di bawahnya.”",
    "thea_before": "Peramal",
    "thea": "THEA",
    "thea_skill_1": "Kebijaksanaan Para Dewa",
    "thea_skill_2": "Jelmaan Para Dewa",
    "thea_skill_3": "",
    "thea_introduction_1": "Peramal yang menerima berkat dari Enam Dewa, menggunakan berkat dari dewa untuk menubuatkan masa depan dan menerapkan Hukuman Dewa.\n“Biarkan ajaran Enam Dewa menuntunmu ke arah itu.”",
    "thea_introduction_2": "Kumpulkan kekuatan besar para dewa, dan wujudkan kembali surga wilayah dewa.\n“Semua yang kulakukan adalah kehendak Dewa.”",
    "erika_before": "Mata kucing",
    "erika": "ERIKA",
    "erika_skill_1": "Angin Kencang Penguntit",
    "erika_skill_2": "Bayangan Kucing Cahaya Petir",
    "erika_skill_3": "",
    "erika_introduction_1": "Gadis bertelinga kucing yang seperti angin kencang, merupakan seorang yang ahli dalam berburu.\n“Hei, aku adalah Erika yang dapat berlari lebih cepat dari kilat!”",
    "erika_introduction_2": "Menjabat sebagai Kepala Peneliti Petir, Erika menghancurkan semua musuh dalam kilatan cahaya petir yang menakjubkan!\n'Selama Erika terus berlari, Torchlight tidak akan pernah kehilangan daya!'",
    "bing_before": "Para penghindar duniawi",
    "bing": "petandang",
    "bing_skill_1": "Ledakan Nova",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "Artis peledak yang sangat bersemangat, pembuat onar yang suka kabur.\n“Karena berhasil mempromosikan bom celana dalam ke Rehan, ia menjadi terkenal dalam sekejap.”",
    "iris_before": "Iblis yang Meninggalkan Dunia",
    "iris": "IRHYS",
    "iris_skill_1": "Angin Pertumbuhan",
    "iris_skill_2": "",
    "iris_introduction_1": "Pasukan Setan yang akrab, angin semilir \nyang tumbuh dengan gigih. \"Kami \ntumbuh, seperti semua makhluk di dunia \nini.\"",
    "iris_introduction_2": "",
    "rosa_before": "Berkilauan",
    "rosa": "Rosa",
    "rosa_skill_1": "Kereta Perang Suci",
    "rosa_introduction_1": "Santo Delan, ksatria magang yang tidak patuh pada aturan, kendaraan perang yang tak terkalahkan di medan perang. \"Roh Kudus akan mengampuni kalian, dan aku akan mengantarkan kalian untuk bertemu Roh Kudus.\"",
    "selena_before": "",
    "selena": "",
    "selena_skill_1": "",
    "selena_introduction_1": "",
    "intro_title": "perkenalan singkat"
  },
  vn: {
    "moto_before": "Quan Chỉ Huy",
    "moto": "Moto",
    "moto_skill_1": "Chiêu Mộ Hiệu Lệnh",
    "moto_skill_2": "Chiêu Mộ Xung Phong",
    "moto_skill_3": "",
    "moto_introduction_1": "Tướng quân đế quốc thống lĩnh đội quân hùng mạnh, là Đạo Sư nhân tạo nghiên cứu về Tro Bụi.\n“Ban đầu chẳng thà nhặt cục sắt vụn còn hơn là nhặt ngươi! “Moto thường nói với cậu con nuôi Bing của mình như thế.",
    "moto_introduction_2": "Thống lĩnh cuồng bạo xông vào trận địa, những cỗ máy chiến tranh lấy bạo trị bạo.\n“Nghe nói vị Người Lùn đáng kính này từng bị mất hàm dưới trong vụ nổ, không biết bộ râu che mặt ông ấy từ đâu mà có. ”",
    "carino_before": "Súng Thánh",
    "carino": "Carino",
    "carino_skill_1": "Du Hiệp Vinh Quang",
    "carino_skill_2": "Ảnh Quét Chí Mạng",
    "carino_skill_3": "",
    "carino_introduction_1": "Du Hiệp quý tộc bảo vệ lẽ phải, chuyên gia đạn dược với tài thiện xạ xuất sắc.\n“Lúc còn bé, Carino cứ khóc nhè gọi ta là chú. Thời gian thấm thoắt thoi đưa! “... Youga than nhẹ.",
    "carino_introduction_2": "Kẻ gánh trên lưng tội giết chồng, thợ săn trí mạng lang thang trong đêm tối.\n“Thay đạn là khoảnh khắc yếu đuối nhất của Xạ Thủ, nhưng anh ấy không giống vậy. ”",
    "rehan_before": "Kẻ Điên Cuồng",
    "rehan": "Rayne",
    "rehan_skill_1": "Lửa Giận",
    "rehan_skill_2": "Nộ Ảnh",
    "rehan_skill_3": "",
    "rehan_introduction_1": "Những chiến binh man rợ biến giận dữ thành sức mạnh, không ngừng tích lũy lửa giận trong cuộc chiến với kẻ thù, càng chiến càng hăng.\nRayne rất thích ca hát. Nghe nói trước khi Tro Bụi hủy diệt mái nhà của anh, anh từng dự định sẽ tổ chức buổi lưu diễn trên cánh đồn tuyết.",
    "rehan_introduction_2": "Những chiến binh man trợ dâng hiến giận dữ lên thần linh để đổi lấy sự bảo hộ, cùng tổ tiên Valragorn kề vai chiến đấu.\nThật ra Rayne rất lo lắng về chuyện bản thân ăn vụn đồ cúng trong Thung Lũng Tổ Tiên lúc còn bé, liệu có bị thần linh nhìn thấy rồi không.",
    "gemma_before": "Lửa Băng",
    "gemma": "Gemma",
    "gemma_skill_1": "Hợp Nhất Băng Lửa",
    "gemma_skill_2": "Trái Tim Đóng Băng",
    "gemma_skill_3": "",
    "gemma_skill_4": "Ngọn Lửa Hân Hoan",
    "gemma_introduction_1": "Hai linh hồn băng lửa hòa hợp, lửa cháy và băng tuyết bầu bạn bên nhau.\n“Lắng nghe cuộc tranh luận từ tiếng lòng của Gemma và đưa ra nhận xét là công việc hàng ngày của Thea. ”",
    "gemma_introduction_2": "Linh hồn cô độc giữa gió tuyết, hàn băng không tan dịu dàng nhưng thấu xương.\n“Erika, mang mấy con chuột ngươi chưa ăn hết ra khỏi giường của ta. Ta không biết cách bảo quản đâu. ”",
    "gemma_introduction_4": "Lễ tiệc cuồng nhiệt trong lửa, kẻ ngốc dưới váy \nsay mê không ngừng \"Đến đây nào, để tôi nếm \nthử hương vị đau khổ của bạn.\"",
    "youga_before": "Nhân Chứng Thời Không",
    "youga": "Youga",
    "youga_skill_1": "Ảo Ảnh Thời Không",
    "youga_skill_2": "Thời Không Trôi Qua",
    "youga_skill_3": "",
    "youga_introduction_1": "Ta là sự kết hợp hoàn hảo giữa ma thuật và khoa học, là con cưng của thời gian và không gian, là trụ cột của Torchlight!\n“Hi! Ta mới là bản thể! Đừng tin lời giả dối bên trên! “--- Youga ảo tưởng",
    "youga_introduction_2": "Ta tưởng rằng chuyện xui xẻo nhất chính là bị dòng chảy hỗn loạn của thời gian nghiền thân thể ra từng mảnh nhỏ, chẳng ngờ sự thật còn thảm hại hơn... Hỗn Loạn Thời Không này dính trên người ta chẳng biến mất!\n“Ta buộc dải băng này lên, chỉ vì muốn xem thử đám chuyên gia vật lý ấy tranh biện nảy lửa ra sao về chuyện ta còn sống hay đã chết. ”",
    "thea_before": "Nhà Tiên Tri",
    "thea": "THEA",
    "thea_skill_1": "Trí Tuệ Chúng Thần",
    "thea_skill_2": "Hóa Thân Chúng Thần",
    "thea_skill_3": "",
    "thea_introduction_1": "Nhà Tiên Tri được Lục Thần chúc phúc, dùng chúc phúc của Thần để dự đoán tương lai, thi triển Thần Phạt.\n“Hãy để lời răn dạy của Lục Thần dẫn đường cho ngươi. ”",
    "thea_introduction_2": "Tập hợp sức mạnh vĩ đại của chúng thần, vực dậy cõi Thần Vực.\n“Những điều ta làm đều tuân theo ý chỉ của thần. ”",
    "erika_before": "Mắt Mèo",
    "erika": "ERIKA",
    "erika_skill_1": "Săn Bắt Gió Mạnh",
    "erika_skill_2": "Bóng Mèo Điện Quang",
    "erika_skill_3": "",
    "erika_introduction_1": "Thiếu nữ tai mèo nhanh nhẹn như gió, là chuyên gia trong lĩnh vực săn bắt.\n“Haha, ta là Erika chạy nhanh hơn cả tia chớp! ”",
    "erika_introduction_2": "Đảm nhiệm vị trí Chủ nhiệm nghiên cứu Tia Chớp, Erica đã tiêu diệt toàn bộ kẻ thù trong những tia Điện Quang kỳ diệu!\n'Chừng nào Erica còn chạy, ngọn lửa Torchlight sẽ không bao giờ tắt điện!'",
    "bing_before": "Kẻ Đào Tẩu",
    "bing": "Lính",
    "bing_skill_1": "Tân Tinh Bùng Nổ",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "Nhà phá hoại nghệ thuật sôi nổi, kẻ gây rắc rối tung tăng nhảy nhót.\n“Vì bán thành công bom hình quần cộc cho Rayne nên nổi tiếng từ đó. ”",
    "iris_before": "Hồn Ma Dị Thế",
    "iris": "IRIS",
    "iris_skill_1": "Gió Nhẹ Sinh Trưởng",
    "iris_skill_2": "",
    "iris_introduction_1": "Đội Hồn Ma là bạn thân thiết, cố gắng \nphát triển như cơn gió nhẹ.\"Chúng ta \nđang lớn lên, giống như muôn vật trong \nthế giới này.\"",
    "iris_introduction_2": "",
    "rosa_before": "Quang Diệu",
    "rosa": "Rosa",
    "rosa_skill_1": "Xe Chiến Thánh Đường",
    "rosa_introduction_1": "Vị hiệp sĩ tập sự không tuân thủ quy tắc của Thánh Đức Lan, chiến xe Thánh Đường không ngừng tiến lên trên chiến trường. \"Thánh Linh sẽ tha thứ cho các ngươi, còn ta sẽ đưa các ngươi đến gặp Thánh Linh.\"",
    "selena_before": "",
    "selena": "",
    "selena_skill_1": "",
    "selena_introduction_1": "",
    "intro_title": "Giới thiệu"
  },
  ru: {
    "moto_before": "Командир",
    "moto": "Мото",
    "moto_skill_1": "Приказ зовет",
    "moto_skill_2": "Призыв к штурму",
    "moto_skill_3": "",
    "moto_introduction_1": "Имперский генерал, возглавляющий элитные войска, наставник синтетического отряда, досконально изучивший эмбер.\n«Лучше бы я подобрал кусок металлолома, чем тебя! »—Зачастую говорит Мото своим солдатам.",
    "moto_introduction_2": "Жестокий лидер, который бросается в бой в первых рядах. Военная машина, порождающая насилие.\n«Говорят, что этот почтенный гном однажды лишился челюсти во время взрыва. Непонятно, откуда взялась борода на его маске».",
    "carino_before": "Божественный выстрел",
    "carino": "Карино",
    "carino_skill_1": "Рейнджер славы",
    "carino_skill_2": "Смертельная вспышка",
    "carino_skill_3": "",
    "carino_introduction_1": "Аристократичный рейнджер, который борется за справедливость, и эксперт по боеприпасам с выдающимся мастерством стрельбы.\n«Когда Карино был ребенком, он всегда плакал и звал меня дядей. Годы не щадят людей!»—Рассуждает Юга на досуге.",
    "carino_introduction_2": "Грешный цареубийца, смертоносный охотник, который бродит во тьме.\n«Перезагрузка патронов — самый уязвимый момент стрелка, но он другой».",
    "rehan_before": "Берсеркер",
    "rehan": "Рихан",
    "rehan_skill_1": "Злость",
    "rehan_skill_2": "Гневная тень",
    "rehan_skill_3": "",
    "rehan_introduction_1": "Воин-варвар, превративший свой гнев в силу. Накапливает гнев в постоянных битвах с врагом и чем больше сражается, тем сильнее становится.\nРихан очень любит петь. Говорят, что до того, как аэмбер разрушил его дом, он планировал провести концертный тур по Снежной равнине.",
    "rehan_introduction_2": "Воин-варвар, который жертвует свой гнев духам предков в обмен на защиту. Сражается бок о бок с предками Варагана.\nРихан на самом деле очень переживает, что предки видели, как он крал и съедал подношения из долины предков, когда был ребенком.",
    "gemma_before": "Ледяной огонь",
    "gemma": "Джемма",
    "gemma_skill_1": "Лед и огонь",
    "gemma_skill_2": "Ледяное сердце",
    "gemma_skill_3": "",
    "gemma_skill_4": "Пламя радости",
    "gemma_introduction_1": "Слитые воедино души льда и огня, яростное пламя и мороз, которые сопровождают друг друга.\n«Слушать голос Джеммы и делать комментарии — это часть распорядка дня Теи».",
    "gemma_introduction_2": "Одинокая душа, которая бродит среди ветра и снега, пронизывающий до костей и не тающий лед.\n«Эрика, убери свою недоеденную мышь с моей кровати. Я не знаю, как сохранить ее свежесть».",
    "gemma_introduction_4": "Бесконечное веселье в огненном пире, \nбезумие слуг под юбкой никогда не утихает. \n\"Давай, позволь мне попробовать вкус твоей \nболи.\"",
    "youga_before": "Свидетель пространства-времени",
    "youga": "Юга",
    "youga_skill_1": "Иллюзия пространства-времени",
    "youga_skill_2": "Течение времени и пространства",
    "youga_skill_3": "",
    "youga_introduction_1": "Я—идеальное сочетание технологии и магии, гордый повелитель времени и пространства и опора Света факелов!\n«Эй! Я—оригинальное тело! Не верьте этой фальшивке!»—Фантом Юги",
    "youga_introduction_2": "Я думал, что хуже всего—быть разбитым вдребезги в колебании временного потока, но еще более трагично то, что это колебание пространства-времени прикреплено ко мне и не исчезает!\n«Я наложил эти бинты просто для того, чтобы посмотреть, борется ли группа физиков за то, останусь ли я жив».",
    "thea_before": "Оракул",
    "thea": "Тея",
    "thea_skill_1": "Мудрость богов",
    "thea_skill_2": "Воплощение богов",
    "thea_skill_3": "",
    "thea_introduction_1": "Оракул, благословленный шестью богами, использует благословения богов, чтобы предсказывать будущее и налагать божественное наказание.\n«Пускай наставления шести богов направят тебя в нужном направлении».",
    "thea_introduction_2": "Соберите великую силу богов, чтобы воссоздать божественное царство.\n«Все, что я делаю,—это воля Божья».",
    "erika_before": "Кошачий глаз",
    "erika": "Эрика",
    "erika_skill_1": "Ураганный сталкер",
    "erika_skill_2": "Молниевая тень кошки",
    "erika_skill_3": "",
    "erika_introduction_1": "Девушка с кошачьими ушами, быстрая, подобно порыву ветра, и искусная охотница.\n«Хе-хе, я Эрика, которая бегает быстрее молнии!»",
    "erika_introduction_2": "Айрика, главный исследователь молний, уничтожает всех врагов среди чудесных электрических вспышек!\n'Пока Айрика продолжает бежать, Свет факелов никогда не потеряет электричество!'",
    "bing_before": "Эскапист",
    "bing": "Пин",
    "bing_skill_1": "Взрывная суперновая",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "Энергичный взрывной артист, нарушитель спокойствия, который готов бежать, спасая свою жизнь.\n«Благодаря успешной продаже Рихану бомбочек в форме штанов он вмиг стал знаменитым».",
    "iris_before": "Наследие мага духов",
    "iris": "Ирис",
    "iris_skill_1": "Ветерок развития",
    "iris_skill_2": "",
    "iris_introduction_1": "Команда Волшебных Духов, близкие спутники, \nплавно набирающий силу ветерок. \n\"Мы растем, как все в этом мире.\"",
    "iris_introduction_2": "",
    "rosa_before": "Обсидиан",
    "rosa": "Роза",
    "rosa_skill_1": "Xe Chiến Thánh Đường",
    "rosa_introduction_1": "Непокорный ученик рыцаря Сант-Делан, неутомимый боевой танк Священного двора на поле битвы. \"Святой дух простит вас, а я отправлю вас к нему.\"",
    "selena_before": "",
    "selena": "",
    "selena_skill_1": "",
    "selena_introduction_1": "",
    "intro_title": "Введение"
  },
  pt: {
    "moto_before": "Comandante",
    "moto": "Moto",
    "moto_skill_1": "Chamadas de Pedidos",
    "moto_skill_2": "Chamada de cobrança",
    "moto_skill_3": "",
    "moto_introduction_1": "O General Imperial que lidera um exército poderoso; o Instrutor da Tropa Mecânica que estuda as Brasas.\n“Você se daria melhor catando sucata de ferro-velho!“ --Moto, que repete bastante essa frase a seu filho adotivo, Bing.",
    "moto_introduction_2": "Um comandante violento que dispara em direção à batalha; uma máquina de guerra que combate a violência com explosões.\n“Diz-se que este venerável anão perdeu a mandíbula em uma explosão. Eu me pergunto de onde veio a barba que há em sua cara.”",
    "carino_before": "Disparo Divino",
    "carino": "Carino",
    "carino_skill_1": "Guarda da Glória",
    "carino_skill_2": "Flash Letal",
    "carino_skill_3": "",
    "carino_introduction_1": "Um nobre guarda que zela pela justiça; um especialista em munição com excelente pontaria.\n“Carino costumava chorar e me chamar de 'tio' quando era pequeno. Os anos foram austeros para nós!“ –Reflexões de Youga.",
    "carino_introduction_2": "Um assassino corrupto; um caçador fatal que vagueia pela escuridão.\n“A recarga de munição é o momento mais vulnerável para o artilheiro, porém ele é diferente“.",
    "rehan_before": "Furioso",
    "rehan": "Rehan",
    "rehan_skill_1": "Ira",
    "rehan_skill_2": "Sombra Furiosa",
    "rehan_skill_3": "",
    "rehan_introduction_1": "Guerreiros bárbaros canalizam sua raiva para ficar mais fortes, acumulando-a em uma série de batalhas e se tornando mais corajosos.\nRennes curte mesmo cantar. Segundo fontes, ele havia planejado uma turnê pelas planícies nevadas, mas a praga da Aember destruiu sua terra natal antes de acontecer.",
    "rehan_introduction_2": "Guerreiros bárbaros dedicam sua raiva aos espíritos ancestrais em troca de proteção, lutando ao lado dos antepassados de Varagon.\nRennes estava preocupado com os espíritos ancestrais terem o visto quando roubou oferendas do Vale dos Ancestrais para comer quando criança.",
    "gemma_before": "Fúria de Fogo",
    "gemma": "Gemma",
    "gemma_skill_1": "Fusão de Gelo e Fogo",
    "gemma_skill_2": "Coração Congelado",
    "gemma_skill_3": "",
    "gemma_skill_4": "Chama Feliz",
    "gemma_introduction_1": "As almas gêmeas de gelo e fogo; a fria chama carregada que os acompanham.\n“Ouvir e discutir as fofocas de Gemma é o pão de cada dia para Thea.”",
    "gemma_introduction_2": "Uma alma solitária entre o vento e a neve; o terno e gentil gelo gelado.\n“Erika, tire seus restos de ratazana da minha cama\". Ela vai apodrecer aqui.”",
    "gemma_introduction_4": "Um banquete frenético de fogo, o prazer \ninterminável, o tolo que se agarra sob a saia. \n\"Vamos lá, deixe-me provar o sabor da sua dor.\"",
    "youga_before": "Testemunha do Espaço-Tempo",
    "youga": "Youga",
    "youga_skill_1": "Ilusão do espaço-tempo",
    "youga_skill_2": "Lapso de Tempo",
    "youga_skill_3": "",
    "youga_introduction_1": "Sou a combinação perfeita de tecnologia e magia, a filha preferida do tempo e do espaço, o carro-chefe do Torchlight!\n“Oie! Sou o melhor que há! Não acredite nessas falcatruas!“ --Youga da Ilusão",
    "youga_introduction_2": "Pensei que ter meus ossos esmagados pela Turbulência do Espaço-Tempo era o fim da linha, mas a triste verdade é que, dessa vez, a turbulência está presa em mim, e veio para ficar!\n“Enfaixei-me todo só para ver se esses físicos estavam mesmo dispostos a lutar por mim.”",
    "thea_before": "Médium",
    "thea": "Sia",
    "thea_skill_1": "Sabedoria dos Deuses",
    "thea_skill_2": "Encarnação dos Deuses",
    "thea_skill_3": "",
    "thea_introduction_1": "O oráculo, abençoado pelos seis deuses, usa os encantos divinos para prever o futuro e administrar a Punição Divina.\n“Deixe os ensinamentos dos seis deuses guiarem seu caminho.”",
    "thea_introduction_2": "Reunindo a grandeza dos deuses, o reino celestial dos deuses é recriado.\n“Que Deus seja a minha vontade.”",
    "erika_before": "Olho de Gato",
    "erika": "ERIKA",
    "erika_skill_1": "Caça-vento",
    "erika_skill_2": "Luz elétrica do Gato",
    "erika_skill_3": "",
    "erika_introduction_1": "Uma menina com orelhas de gato veloz como o vento; um mestre caçador perito na arte da caça.\n“Oie! Sou Erika, a menina que corre na velocidade da luz!”",
    "erika_introduction_2": "Atuando como a principal pesquisadora de trovões, Erika elimina todos os inimigos entre as maravilhosas luzes cintilantes!\n'Enquanto Erika continuar correndo, a Torchlight nunca se apagará!'",
    "bing_before": "Escapista",
    "bing": "PIN",
    "bing_skill_1": "Nova Explosiva",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "Um artista de explosões; um encrenqueiro que corre feliz para salvar a própria vida.\n“Por ter obtido sucesso nas vendas das calças explosivas, Rennes virou celebridade.”",
    "iris_before": "Mago Espiritual das Eras",
    "iris": "ÍRIS",
    "iris_skill_1": "Brisa Crescente",
    "iris_skill_2": "",
    "iris_introduction_1": "O companheiro íntimo da equipe Mago \nEspiritual, o vento suave que cresce \nconstantemente.\"Estamos crescendo, \nassim como tudo neste mundo.\"",
    "iris_introduction_2": "",
    "rosa_before": "Brilho da Luz",
    "rosa": "Rosa",
    "rosa_skill_1": "Carro de Guerra do Santuário",
    "rosa_introduction_1": "Cavaleiro aprendiz indisciplinado de Saint Delan, o carro de guerra do sagrado tribunal que avança destemidamente no campo de batalha. \"O Espírito Santo perdoará vocês, e eu os levarei para encontrar o Espírito Santo.\"",
    "selena_before": "",
    "selena": "",
    "selena_skill_1": "",
    "selena_introduction_1": "",
    "intro_title": "breve introdução"
  },
  fr: {
    "moto_before": "Commandant",
    "moto": "Moto",
    "moto_skill_1": "Appel à l'ordre",
    "moto_skill_2": "Appel à la charge",
    "moto_skill_3": "",
    "moto_introduction_1": "Le général impérial qui a dirigé une puissante armée et le tuteur de mécanique intelligente qui étudie les cendres.\n«Il vaut mieux de ramasser un morceau de ferraille que de toi !»--Moto disait souvent cela à son fils adoptif, Bing.",
    "moto_introduction_2": "Un commandant cruel qui s'engage dans la bataille, une machine de guerre qui combat la violence par la violence.\n«Ce vénérable nain a perdu sa mâchoire dans l'explosion, et on ne sait pas d'où vient la barbe sur son masque.»",
    "carino_before": "Tir divin",
    "carino": "Carino",
    "carino_skill_1": "Ranger de la gloire",
    "carino_skill_2": "Flash létal",
    "carino_skill_3": "",
    "carino_introduction_1": "Un noble chevalier errant qui respecte la justice, un expert en munitions avec une excellente méthode de tir.\n«Carino m'appelait oncle toujours en pleurant quand il était enfant. Le temps n'attend personne !»--Les pensées oisives de Youga",
    "carino_introduction_2": "Un régicide au cœur pécheur, un chasseur mortel qui rôde dans les ténèbres.\n«Le changement de munitions est le moment le plus vulnérable pour un tireur, mais pas pour lui.»",
    "rehan_before": "Berserk",
    "rehan": "Rehan",
    "rehan_skill_1": "Colère",
    "rehan_skill_2": "Ombre colère",
    "rehan_skill_3": "",
    "rehan_introduction_1": "Le Guerrier barbare qui transforme sa colère en force accumule sa rage dans pendant les combats constants avec ses ennemis et en devenant de plus en plus courageux.\nRehan aime bien chanter. Il aurait prévu une tournée de concerts sur la plaine couverte de neige avant que les Aembers ne détruisent sa maison.",
    "rehan_introduction_2": "Les Guerriers barbares qui dédient leur rages à leurs esprits ancestraux en échange de la protection se battent aux côtés des ancêtres de Varagon.\nRehan était en fait très nerveux si il avait été observée par les esprits ancestraux lorsqu'il volait des offrandes dans la vallée des ancêtres.",
    "gemma_before": "Feu de givre",
    "gemma": "Gemma",
    "gemma_skill_1": "Fusion de feu et de glace",
    "gemma_skill_2": "Cœur de morsure de froid",
    "gemma_skill_3": "",
    "gemma_skill_4": "Llama de Placer",
    "gemma_introduction_1": "L'âme double de la fusion de glace et de feu, accompagnée de flamme et de givre.\n«Écouter les querelles de la voix du cœur de Gemma et les commenter est un programme quotidien pour Xiya.»",
    "gemma_introduction_2": "Une âme solitaire entre le vent et la neige, une glace douce et mordante qui ne fond pas.\n«Erika, enlève ton rat non mangé de mon lit. Je ne sais pas comment le garder frais.»",
    "gemma_introduction_4": "Un festin de feu et de folie sans fin, des idiots \nenchevêtrés sous la jupe. \"Allez, laissez-moi \ngoûter à la saveur de votre douleur.\"",
    "youga_before": "Témoin de l'espace-temps",
    "youga": "Youga",
    "youga_skill_1": "Illusion d'espace-temps",
    "youga_skill_2": "Passage de l'espace-temps",
    "youga_skill_3": "",
    "youga_introduction_1": "Je suis la combinaison parfaite de la technologie et de la magie, le favori du temps et de l'espace, le pilier de Torchlight !\n«Hé ! Je suis le vrai corps ! Ne crois pas celle en haut ! «--Illusion Youga",
    "youga_introduction_2": "Je pensais d'avoir le corps pulvérisé dans une turbulence temporelle était la pire chose, mais la vérité la plus tragique est que--cette turbulence temporelle est collée à moi et ne veut pas partir !\n«J'ai mis ce bandage juste pour voir si le groupe de physiciens se disputait pour ma vie.»",
    "thea_before": "Oracle",
    "thea": "XIYA",
    "thea_skill_1": "Sagesse des Dieux",
    "thea_skill_2": "Incarnation des Dieux",
    "thea_skill_3": "",
    "thea_introduction_1": "L'Oracle, béni par les Six Dieux, utilise les bénédictions de Dieu pour prophétiser l'avenir et lance le Châtiment divin.\n«Les enseignements des Six Dieux vous guideront.»",
    "thea_introduction_2": "Rassembler la force colossale des dieux pour recréer le royaume céleste de domaine divin.\n«Tout ce que je fais, est la volonté de Dieu.»",
    "erika_before": "Œil de chat",
    "erika": "ERIKA",
    "erika_skill_1": "Chasse de fort vent",
    "erika_skill_2": "Lumière de chat",
    "erika_skill_3": "",
    "erika_introduction_1": "Une fille aux oreilles de chat avec la vitesse du vent est un maître chasseur qui maîtrise la poursuite.\n«Héhé, je suis Erika, qui court plus vite que l'éclair !»",
    "erika_introduction_2": "En tant que chercheuse principale en éclairs, Erika élimine tous les ennemis dans l'éblouissant éclairage merveilleux !\n`Tant qu'Erika continue de courir, Torchlight ne s'éteindra jamais !`",
    "bing_before": "Escapiste",
    "bing": "PinMa",
    "bing_skill_1": "Nova de l'explosion",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "Un artiste de démolition grandiose, un fauteurs de troubles heureux de courir tout le temps.\n«Il est devenu célèbre pour avoir réussi à vendre des bombes de type culotte à Rehan.»",
    "iris_before": "Esprit Magus abandonné",
    "iris": "IRIS",
    "iris_skill_1": "Brise de croissance",
    "iris_skill_2": "",
    "iris_introduction_1": "Les compagnons intimes de l'équipe \nEsprit Magus, une brise légère qui grandit \navec effort.\"Nous grandissons, comme \ntoutes les choses en ce monde.\"",
    "iris_introduction_2": "",
    "rosa_before": "Splendeur",
    "rosa": "Rosa",
    "rosa_skill_1": "Char de la Haute Cour",
    "rosa_introduction_1": "Chevalier en formation indiscipliné de Saint-Déran, char de combat intrépide du Saint Tribunal sur le champ de bataille. \"L'Esprit Saint vous pardonnera, et moi, je vous enverrai le rencontrer.\"",
    "selena_before": "",
    "selena": "",
    "selena_skill_1": "",
    "selena_introduction_1": "",
    "intro_title": "Introduction"
  },
  es: {
    "moto_before": "Comandante",
    "moto": "Moto",
    "moto_skill_1": "Llamada a las armas",
    "moto_skill_2": "Cobro de llamadas",
    "moto_skill_3": "",
    "moto_introduction_1": "El General Imperial que dirige la fuerza armada es también un mentor de tropa sintética que estudia las cenizas.\n“¡No mereces los esfuerzos que hice para adoptarte!“ Moto a menudo le dijo a su hijo adoptivo Bing.",
    "moto_introduction_2": "El líder violento de la carga también es una máquina de guerra usando la explosión contra la violencia.\n“Dicen que el respetable enano perdió la mandíbula en una explosión y nadie supo de dónde salía la barba en su máscara.”",
    "carino_before": "Disparo Divino",
    "carino": "Carino",
    "carino_skill_1": "Ranger de la Gloria",
    "carino_skill_2": "Destello letal",
    "carino_skill_3": "",
    "carino_introduction_1": "El ranger noble que se adhiere a la justicia es también experto en municiones con excelentes habilidades de tiro.\n“Carino siempre me llamaba tío llorando cuando era niño. ¡El tiempo pasa rápido!“ Suspiro de Youga en el ocio.",
    "carino_introduction_2": "Un regicida pecaminoso es también un cazador mortal que camina por la oscuridad.\n“El cambio de bala es el momento más débil para un pistolero, pero él es diferente.”",
    "rehan_before": "Berserker",
    "rehan": "Rehan",
    "rehan_skill_1": "Rabia",
    "rehan_skill_2": "Sombra Furiosa",
    "rehan_skill_3": "",
    "rehan_introduction_1": "Los guerreros bárbaros convirtieron su furia en fuerza y acumularon constantemente la ira en las batallas contra los enemigos y se volvieron cada vez más valientes.\nA Rehan le gusta mucho cantar. Dicen que había planeado una gira de conciertos en el campo de nieve antes de que el Aember destruyeran su hogar.",
    "rehan_introduction_2": "Los guerreros bárbaros que dedicaron su ira a los antepasados a cambio de protección lucharon codo con codo con los antepasados de Valgang.\nEn realidad, Rehan estaba muy preocupado por si los antepasados le habían visto robando ofrendas en el Valle de los Antepasados cuando era niño.",
    "gemma_before": "Fuego de Helado",
    "gemma": "Gemma",
    "gemma_skill_1": "Fusión de hielo y fuego",
    "gemma_skill_2": "Corazón de congelación",
    "gemma_skill_3": "",
    "gemma_skill_4": "Llama de Placer",
    "gemma_introduction_1": "El doble alma de hielo y fuego está acompañado de llama e hielo.\n“El programa reservado diario de Shea cuenta con escuchar las peleas en el corazón de Jemima y hacer comentarios.”",
    "gemma_introduction_2": "El alma solitaria entre el viento y la nieve es como el hielo congelado cortante.\n“Erika, coge el ratón que no has comido de mi cama. No sé cómo conservarlo.”",
    "gemma_introduction_4": "Un festín ardiente de éxtasis sin fin, con tontos \nsirvientes que no dejan de enredarse bajo la \nfalda. “Ven, déjame probar el sabor de tu \ndolor.”",
    "youga_before": "Testigo del espacio-tiempo",
    "youga": "Youga",
    "youga_skill_1": "Ilusión del espaciotemporal",
    "youga_skill_2": "Lapso de tiempo",
    "youga_skill_3": "",
    "youga_introduction_1": "¡Soy una combinación perfecta de tecnología y magia, la favorita del tiempo y el espacio y el pilar fundamental de Torchlight!\n“¡Oye! ¡Soy yo, el cuerpo verdadero! ¡No crees en ese falso!“ Ilusión de Youga",
    "youga_introduction_2": "¡Pensé que la destrucción en la turbulencia del tiempo ya era lo pésimo, pero el hecho más miserable es que esta turbulencia del espacio-tiempo no me deja libre!\n“Me puse este vendaje para ver si ese grupo de físicos discutían de si estaba vivo.”",
    "thea_before": "El Oráculo",
    "thea": "SHEA",
    "thea_skill_1": "Sabiduría de los Dioses",
    "thea_skill_2": "Transformación de los Dioses",
    "thea_skill_3": "",
    "thea_introduction_1": "El Oráculo que ha recibido la Bendición de los Seis Dioses hace la profecía del futuro aplicando la Bendición de Dios y ejecuta el Castigo Divino.\n“Que las enseñanzas de los seis dioses te guíen.”",
    "thea_introduction_2": "Reúnan los poderes de los dioses, reproduzca el Reino del Dominio de Dioses.\n“Todo lo que hago es por el oráculo de Dios.”",
    "erika_before": "Cateye",
    "erika": "ERIKA",
    "erika_skill_1": "Retribución de Ventolera",
    "erika_skill_2": "Sombra de gato electro óptico",
    "erika_skill_3": "",
    "erika_introduction_1": "La chica con orejas felinas como ventolera, es una maestra competente en la caza.\n“Jeje, soy Erika que corre más rápido que el rayo.”",
    "erika_introduction_2": "Erika, la Jefa de Investigación de Rayos, elimina a todos los enemigos en un maravilloso espectáculo de relámpagos chispeantes.\n'Mientras Erika siga corriendo, ¡Torchlight nunca se apagará!'",
    "bing_before": "Escapista",
    "bing": "Pin",
    "bing_skill_1": "Nova de explosión",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "El artista maestro en explosión es un alborotador.\n“Se hizo famoso por vender con éxito bomba explosiva en forma de calzoncillos a Rehan.”",
    "iris_before": "Hexpíritu Abandonada",
    "iris": "Jemima",
    "iris_skill_1": "Llama de Placer",
    "iris_skill_2": "",
    "iris_introduction_1": "Un festín ardiente de éxtasis sin fin, con \ntontos sirvientes que no dejan de \nenredarse bajo la falda. “Ven, déjame \nprobar el sabor de tu dolor.”",
    "iris_introduction_2": "",
    "rosa_before": "Brillante",
    "rosa": "Rosa",
    "rosa_skill_1": "Carro de batalla del Santuario",
    "rosa_introduction_1": "Caballera aprendiz indisciplinada de San Derain, carro de combate del sagrado tribunal que avanza sin temor en el campo de batalla. \"El Santo Espíritu os perdonará, y yo os enviaré a encontrarse con el Santo Espíritu .\"",
    "selena_before": "",
    "selena": "",
    "selena_skill_1": "",
    "selena_introduction_1": "",
    "intro_title": "Introducción"
  },
  de: {
    "moto_before": "Kommandant",
    "moto": "Moto",
    "moto_skill_1": "Befehl zur Einberufung",
    "moto_skill_2": "Ladung Abrufen",
    "moto_skill_3": "",
    "moto_introduction_1": "Ein imperialer General, der das Elitekommando anführt, und gleichzeitig ein akademischer Mentor, der die Asche studiert.\n„Ich hätte damals ein Stück Schrott statt dich mitnehmen sollen!“ – Etwas, was Moto oftmals seinen Adoptivsoldaten an den Kopf wirft.",
    "moto_introduction_2": "Ein gewalttätiger Anführer, der sich in die Schlacht stürzt, und er ist auch eine Kriegsmaschine, die Gewalt mit noch mehr Gewalt erwidert.\n„Man sagt, dass dieser angesehene Zwerg einst seinen Kiefer bei einer Explosion eingebüßt hat, und niemand weiß, wie der Bart auf seiner Maske entstanden ist.“",
    "carino_before": "Göttlicher Schuss",
    "carino": "Carino",
    "carino_skill_1": "Waldläufer des Ruhmes",
    "carino_skill_2": "Tödlicher Blitz",
    "carino_skill_3": "",
    "carino_introduction_1": "Ein adeliger Waldläufer, der sich für die Gerechtigkeit einsetzt, der auch ein Munitionsexperte mit hervorragender Schießkunst ist.\n„Als Carino noch klein war, hat er mich immer weinerlich „Onkel“ gerufen. Wie die Zeit vergeht!“–Yougas Seufzer.",
    "carino_introduction_2": "Ein sündhafter Königsmörder und ein todbringender Jäger, der in der Dunkelheit wandelt.\n„Schützen sind normalerweise beim Munitionswechsel am verwundbarsten, doch er stellt eine Ausnahme dar.“",
    "rehan_before": "Berserker",
    "rehan": "Rehan",
    "rehan_skill_1": "Wütendes Feuer",
    "rehan_skill_2": "Zorniger Schatten",
    "rehan_skill_3": "",
    "rehan_introduction_1": "Ein Barbarenkrieger, der über die Fähigkeit verfügt, seinen Zorn in Stärke umzuwandeln, und der in den endlosen Kämpfen mit dem Feind seine Wut bündeln kann, um immer wilder zu werden.\nRaine liebt es zu singen. Es wird erzählt, dass er, bevor die Aember-Katastrophe seine Heimat zerstörte, geplant hatte, eine Konzerttournee auf dem Schneefeld zu veranstalten.",
    "rehan_introduction_2": "Ein Barbarenkrieger, der seinen Zorn den Ahnengeistern widmete, um im Gegenzug Schutz zu erhalten, kämpft Seite an Seite mit seinen Vorfahren Varagon.\nEigentlich macht sich Raine am meisten Sorgen darüber, ob die Ahnengeister ihn damals, als er noch klein war, beim Stehlen der Opferspeise beobachtet haben.",
    "gemma_before": "Frostfeuer",
    "gemma": "Gemma",
    "gemma_skill_1": "Illusion der Raumzeit",
    "gemma_skill_2": "Herz der Eisknote",
    "gemma_skill_3": "",
    "gemma_skill_4": "Flamme der Freude",
    "gemma_introduction_1": "Die verschmolzenen Seelen von Eis und Feuer umschlingen sich wie eine eisige Stichflamme.\n„Den Streit zwischen Gemmas Stimmen zu belauschen und zu kommentieren, gehört zu Theas täglichen Lieblingsbeschäftigungen.“",
    "gemma_introduction_2": "Die einsame Seele inmitten von Wind und Schnee ist wie eine zahme und doch beißende Eiseskälte.\n„Erika, nimm gefälligst deine halb gefressene Ratte aus meinem Bett! Ich werde sie nicht für dich frischhalten.“",
    "gemma_introduction_4": "Ein feuriges Fest der Ekstase ohne Ende, unter \ndem Rock verstrickte Narren, die nie aufhören. \n\"Komm, lass mich den Geschmack deines \nSchmerzes kosten.\"",
    "youga_before": "Raumzeit Zeuge",
    "youga": "Youga",
    "youga_skill_1": "Verdrehte Raumzeit",
    "youga_skill_2": "Vergehender Raumzeit",
    "youga_skill_3": "",
    "youga_introduction_1": "Ich bin die perfekte Kombination aus Technologie und Magie, der große Liebling von Zeit und Raum und die Hauptfigur von Torchlight!\n„Hey! Ich bin der Wahre! Glaubt diesem Scharlatan nicht!“–Illusion-Youga",
    "youga_introduction_2": "Ich dachte schon, es gäbe nichts Schlimmeres, als in der Raumzeit-Turbulenz in Stücke gerissen zu werden, aber die noch tragischere Wahrheit ist, dass diese Raumzeit-Turbulenz an mir hängen geblieben ist und sich nicht auflösen will!\n„Ich habe mich selbst nur deshalb mit dieser Bandage eingewickelt, um zu sehen, ob sich die Gruppe von Physikern darüber streiten würde, ob ich unter der Bandage noch am Leben bin.“",
    "thea_before": "Orakel",
    "thea": "SIA",
    "thea_skill_1": "Göttliche Weisheit",
    "thea_skill_2": "Inkarnation der Götter",
    "thea_skill_3": "",
    "thea_introduction_1": "Das von den sechs Göttern gesegnete Orakel bedient sich des Segens der Götter, um die Zukunft vorherzusagen und die Gottesbestrafung auszuführen.\n„Lass dir von der Lehre der sechs Götter den Weg weisen.“",
    "thea_introduction_2": "Bündle die großartige Macht der Götter und bringe das göttliche Königreich zu seinem früheren Glanz.\n„Alles, was ich tue, geschieht nach dem Willen der Götter.“",
    "erika_before": "Katzenauge",
    "erika": "ERIKA",
    "erika_skill_1": "Stürmische Hetzjagd",
    "erika_skill_2": "Blitzkatze",
    "erika_skill_3": "",
    "erika_introduction_1": "Das junge Mädchen mit den Katzenohren ist geschwind wie der Wind und eine Meisterjägerin, die sich auf die Jagd versteht.\n„Hähä, ich bin Erika, die noch schneller ist als der Blitz!“",
    "erika_introduction_2": "Als leitende Blitzforscherin vernichtet Erika alle Feinde im wunderbaren Elektrifizieren!\n'Solange Erika weiterläuft, wird das Fackellicht niemals erlöschen!'",
    "bing_before": "Eskapist",
    "bing": "Pin",
    "bing_skill_1": "Explosionsnova",
    "bing_skill_2": "",
    "bing_skill_3": "",
    "bing_introduction_1": "Ein energiegeladener Sprengkünstler, und ein waghalsiger Unruhestifter.\n„Dank des erfolgreichen Verkaufs von Unterhosenbomben an Raine wurde er schlagartig berühmt.“",
    "iris_before": "Dämonengeist der Alten Welt",
    "iris": "IRIS",
    "iris_skill_1": "Sanfter Wind des Wachstums",
    "iris_skill_2": "",
    "iris_introduction_1": "Der enge Begleiter des Geistermagus-Teams, \ndie stetig wachsende sanfte Brise. \n\"Wir wachsen, wie alles in dieser Welt.\"",
    "iris_introduction_2": "",
    "rosa_before": "Glänzend",
    "rosa": "Rosa",
    "rosa_skill_1": "Heiliger Panzer",
    "rosa_introduction_1": "Der unkonventionelle Auszubildende Ritter von St. Delan, der unerschrockene Heilige Kriegswagen auf dem Schlachtfeld. \"Der Heilige Geist wird euch vergeben, und ich werde euch zum Heiligen Geist führen.\"",
    "selena_before": "",
    "selena": "",
    "selena_skill_1": "",
    "selena_introduction_1": "",
    "intro_title": "kurze Einführung"
  }
}

export default locales;
